/* ============================================================
   Ecrilo — Stories vidéo shoppables · rail + viewer
   Aucune dépendance. Le rail ne charge que des posters ; les previews
   démarrent en entrant dans l'écran ; le viewer est construit à la
   première ouverture, une seule <video> montée à la fois, la suivante
   préchauffée. Gestes, clavier, focus-trap, reduced-motion, tolérance
   aux pannes, état « vu » persistant, tracking vers Fluviqa Tracking.
   ============================================================ */
(function () {
  "use strict";
  var doc = document;
  var previewsOff = false;
  try { previewsOff = localStorage.getItem("ecrilo:stories:previews") === "off"; } catch (e) {}
  function setInert(on, keep) {
    Array.prototype.forEach.call(doc.body.children, function (el) { if (!el.contains(keep)) el.inert = on; });
  }
  var section = doc.querySelector("[data-ec-stories]");
  if (!section) return;

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveData = navigator.connection && navigator.connection.saveData === true;
  var root = doc.querySelector("[data-ec-variant]");
  var VARIANT = (root && root.getAttribute("data-ec-variant")) || "A";
  var SEEN_KEY = "ecrilo:stories:seen";

  /* ── Tracking (même enveloppe que ecrilo-landing.js) ─────────── */
  var seenEvents = {};
  function track(action, catalog, params, ctaId) {
    var payload = { ecrilo: true, catalog: catalog, action: action, variant: VARIANT,
                    component_id: "C17", cta_id: ctaId || null, params: params || {} };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        var p = window.Shopify.analytics.publish("ecrilo:" + action, payload);
        if (p && typeof p.catch === "function") p.catch(function () {});
      }
      doc.dispatchEvent(new CustomEvent("ecrilo:track", { detail: payload }));
    } catch (e) {}
  }
  function once(key, fn) { if (seenEvents[key]) return; seenEvents[key] = true; fn(); }

  /* ── État « vu » ───────────────────────────────────────────────── */
  function loadSeen() { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"); } catch (e) { return []; } }
  function markSeen(id) {
    var s = loadSeen(); if (s.indexOf(id) < 0) s.push(id);
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(s.slice(-50))); } catch (e) {}
    section.querySelectorAll('[data-ec-story="' + id + '"]').forEach(function (b) { b.classList.add("is-seen"); });
  }
  loadSeen().forEach(markSeen);

  /* ── Rail : previews à l'entrée dans l'écran, affordance de défilement ── */
  var scroller = section.querySelector("[data-ec-stories-rail]");
  var bubbles = Array.prototype.slice.call(section.querySelectorAll("[data-ec-story]"));
  var canPreview = !reduced && !saveData && "IntersectionObserver" in window;

  // Les bulles actuellement à l'écran. Un IntersectionObserver ne parle qu'aux
  // CHANGEMENTS de visibilité : quand on relance les aperçus sans que rien
  // n'ait bougé, il reste muet. Sans cette liste, « Relancer » ne rejouait
  // donc aucune vidéo tant qu'on n'avait pas fait défiler la page.
  var visibles = [];

  function jouerApercu(bulle) {
    if (previewsOff || !bulle) return;
    var v = bulle.querySelector(".ec-story__preview");
    if (!v) return;
    // `preload="none"` : sans source déclarée, `play()` échoue en silence.
    if (!v.src && !v.querySelector("source")) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && p.then) p.then(function () { bulle.classList.add("is-previewing"); }).catch(function () {});
    else bulle.classList.add("is-previewing");
  }

  function arreterApercu(bulle) {
    if (!bulle) return;
    var v = bulle.querySelector(".ec-story__preview");
    if (v) { try { v.pause(); } catch (e) {} }
    bulle.classList.remove("is-previewing");
  }

  if (canPreview) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = visibles.indexOf(en.target);
        if (en.isIntersecting) {
          if (i < 0) visibles.push(en.target);
          jouerApercu(en.target);
        } else {
          if (i >= 0) visibles.splice(i, 1);
          arreterApercu(en.target);
        }
      });
    }, { threshold: 0.6 });
    bubbles.forEach(function (b) { pio.observe(b); });
  }
  function updateFade() {
    if (!scroller) return;
    var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    section.classList.toggle("is-at-end", atEnd);
  }
  if (scroller) { scroller.addEventListener("scroll", updateFade, { passive: true }); updateFade(); window.addEventListener("resize", updateFade); }
  var nextBtn = section.querySelector("[data-ec-stories-next]");
  if (nextBtn && scroller) nextBtn.addEventListener("click", function () { scroller.scrollBy({ left: scroller.clientWidth * 0.7, behavior: reduced ? "auto" : "smooth" }); });

  bubbles.forEach(function (b, i) {
    once("impression:" + b.getAttribute("data-ec-story"), function () {
      track("story_impression", "media_interaction", { story_id: b.getAttribute("data-ec-story"), index: i });
    });
    b.addEventListener("click", function () { openViewer(i); });
  });

  /* ── Viewer : construit à la première ouverture ───────────────── */
  var feeds = bubbles.map(function (b) { try { return JSON.parse(b.querySelector("[data-ec-story-feed]").textContent); } catch (e) { return null; } });
  var viewer = null, V = {}, state = { reel: 0, seg: 0, playing: false, muted: true, video: null, next: null, watchdog: 0, opener: null, restoreY: 0 };

  function build() {
    var tpl = doc.querySelector("[data-ec-stories-viewer]"); if (!tpl) return null;
    viewer = tpl.content.firstElementChild.cloneNode(true);
    doc.body.appendChild(viewer);
    V = {
      bars: viewer.querySelector("[data-ec-viewer-bars]"), title: viewer.querySelector("[data-ec-viewer-title]"),
      media: viewer.querySelector("[data-ec-viewer-media]"), caption: viewer.querySelector("[data-ec-viewer-caption]"),
      cta: viewer.querySelector("[data-ec-viewer-cta]"), ctaLabel: viewer.querySelector("[data-ec-viewer-cta-label]"),
      toggle: viewer.querySelector("[data-ec-viewer-toggle]"), mute: viewer.querySelector("[data-ec-viewer-mute]"),
      close: viewer.querySelector("[data-ec-viewer-close]")
    };
    viewer.querySelectorAll("[data-ec-viewer-prev]").forEach(function (b) { b.addEventListener("click", function (e) { e.stopPropagation(); prev(); }); });
    viewer.querySelectorAll("[data-ec-viewer-next]").forEach(function (b) { b.addEventListener("click", function (e) { e.stopPropagation(); next(); }); });
    V.toggle.addEventListener("click", function (e) { e.stopPropagation(); togglePlay(); });
    V.mute.addEventListener("click", function (e) { e.stopPropagation(); setMuted(!state.muted); });
    V.close.addEventListener("click", function (e) { e.stopPropagation(); closeViewer("button"); });
    V.cta.addEventListener("click", function (ev) {
      var href = V.cta.getAttribute("href") || "";
      if (href.indexOf("/cart/") === 0) { ev.preventDefault(); setTimeout(function () { window.location.assign(href); }, 120); }
      track("story_cta_click", "cta_click", { story_id: feeds[state.reel].id, segment: state.seg }, "story_cta");
      closeViewer("cta");
    });
    viewer.addEventListener("keydown", onKey);
    bindGestures(viewer.querySelector(".ec-viewer__stage"));
    try { state.muted = localStorage.getItem("ecrilo:stories:muted") !== "0"; } catch (e) {}
    return viewer;
  }

  function openViewer(i) {
    if (!viewer && !build()) return;
    state.opener = doc.activeElement; state.restoreY = window.scrollY;
    state.reel = i; state.seg = 0;
    doc.body.classList.add("ec-viewer-open");
    viewer.classList.add("is-open"); viewer.setAttribute("aria-hidden", "false"); setInert(true, viewer);
    renderReel();
    V.close.focus();
    once("open:" + feeds[i].id + ":" + Date.now(), function () {});
    track("story_open", "media_interaction", { story_id: feeds[i].id, index: i });
  }
  function closeViewer(how) {
    if (!viewer) return;
    stopVideo();
    viewer.classList.remove("is-open"); viewer.setAttribute("aria-hidden", "true"); setInert(false, viewer);
    doc.body.classList.remove("ec-viewer-open");
    track("story_close", "media_interaction", { story_id: feeds[state.reel].id, segment: state.seg, how: how });
    if (state.opener && state.opener.focus) state.opener.focus();
    window.scrollTo({ top: state.restoreY, behavior: "auto" });
  }

  function renderReel() {
    var f = feeds[state.reel]; if (!f) return closeViewer("empty");
    V.title.textContent = f.titre || "";
    V.ctaLabel.textContent = (f.cta && f.cta.label) || V.ctaLabel.textContent;
    V.cta.setAttribute("href", (f.cta && f.cta.href) || "#commander");
    V.bars.innerHTML = "";
    f.segments.forEach(function (_, k) {
      var b = doc.createElement("span"); b.className = "ec-viewer__bar"; b.setAttribute("role", "progressbar");
      b.setAttribute("aria-valuemin", "0"); b.setAttribute("aria-valuemax", "100"); b.setAttribute("aria-valuenow", "0"); b.setAttribute("aria-label", "Clip " + (V.bars.children.length + 1));
      var fill = doc.createElement("i"); b.appendChild(fill); V.bars.appendChild(b);
    });
    renderSegment();
  }

  // Shopify transcode en paliers 480p/720p/1080p (MP4 + HLS) ; l'ordre des
  // sources n'est pas contractuel et le m3u8 n'est lu nativement que par
  // Safari. On monte UN rendu : le plus petit MP4 dont la hauteur couvre
  // l'affichage, sinon le plus grand ; HLS seulement faute de MP4 et si lu.
  function viewerTargetHeight() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    return Math.ceil(Math.min(window.innerHeight || 800, 1080) * dpr);
  }
  function pickSource(sources, targetH) {
    var mp4 = (sources || []).filter(function (x) { return x.format === "mp4" || x.type === "video/mp4"; })
      .sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
    if (mp4.length) {
      for (var i = 0; i < mp4.length; i++) if ((mp4[i].height || 0) >= targetH) return mp4[i];
      return mp4[mp4.length - 1];
    }
    var hls = (sources || []).filter(function (x) { return /mpegurl/i.test(x.type || "") || x.format === "m3u8"; })[0];
    var probe = doc.createElement("video");
    return hls && probe.canPlayType && probe.canPlayType("application/vnd.apple.mpegurl") ? hls : null;
  }
  function mountSource(video, sources, targetH) {
    var src = pickSource(sources, targetH);
    if (!src) { video.dispatchEvent(new Event("error")); return; }
    var so = doc.createElement("source"); so.src = src.url; so.type = src.type || "video/mp4"; video.appendChild(so);
  }

  function renderSegment() {
    var f = feeds[state.reel], s = f.segments[state.seg];
    if (!s) return nextReel();
    stopVideo();
    V.media.innerHTML = "";
    V.caption.textContent = s.legende || "";
    var v = doc.createElement("video");
    v.setAttribute("playsinline", ""); v.setAttribute("webkit-playsinline", ""); v.preload = "auto";
    v.muted = state.muted; v.poster = s.poster || ""; v.controls = reduced;
    mountSource(v, s.sources, viewerTargetHeight());
    v.addEventListener("timeupdate", onTime);
    v.addEventListener("ended", function () { advance("ended"); });
    v.addEventListener("error", function () { advance("error"); });
    v.addEventListener("stalled", armWatchdog);
    V.media.appendChild(v); state.video = v;
    V.bars.querySelectorAll(".ec-viewer__bar").forEach(function (b, k) { b.classList.toggle("is-done", k < state.seg); b.classList.toggle("is-current", k === state.seg); b.querySelector("i").style.transform = k < state.seg ? "scaleX(1)" : "scaleX(0)"; });
    if (!reduced) v.play().then(function () { state.playing = true; V.toggle.textContent = "❚❚"; V.toggle.setAttribute("aria-label", "Pause"); }).catch(function () { state.playing = false; V.toggle.textContent = "▶"; });
    warmNext();
    armWatchdog();
    once("view:" + f.id + ":" + state.seg, function () { track("story_view", "media_interaction", { story_id: f.id, segment: state.seg }); });
  }
  function warmNext() {
    var f = feeds[state.reel], s = f.segments[state.seg + 1] || (feeds[state.reel + 1] && feeds[state.reel + 1].segments[0]);
    if (state.next) { state.next.remove(); state.next = null; }
    if (!s || saveData) return;
    var w = doc.createElement("video"); w.preload = "metadata"; w.muted = true; w.style.display = "none";
    mountSource(w, s.sources, viewerTargetHeight());
    V.media.appendChild(w); state.next = w;
  }
  function onTime() {
    var v = state.video; if (!v || !v.duration) return;
    var pct = Math.min(1, v.currentTime / v.duration);
    var bar = V.bars.children[state.seg]; if (bar) { bar.querySelector("i").style.transform = "scaleX(" + pct + ")"; bar.setAttribute("aria-valuenow", String(Math.round(pct * 100))); }
  }
  function armWatchdog() {
    clearTimeout(state.watchdog);
    var s = feeds[state.reel] && feeds[state.reel].segments[state.seg];
    var ms = ((s && s.duree) || 15) * 1000 + 4000;
    state.watchdog = setTimeout(function () { if (state.playing) advance("watchdog"); }, ms);
  }
  function stopVideo() { clearTimeout(state.watchdog); if (state.video) { try { state.video.pause(); } catch (e) {} state.video.remove(); state.video = null; } state.playing = false; }
  function advance(why) {
    var f = feeds[state.reel];
    if (state.seg + 1 < f.segments.length) { state.seg++; renderSegment(); return; }
    once("complete:" + f.id, function () { track("story_complete", "media_interaction", { story_id: f.id, why: why }); });
    markSeen(f.id);
    nextReel();
  }
  function next() { track("story_next", "media_interaction", { story_id: feeds[state.reel].id, segment: state.seg }); advance("tap"); }
  function prev() {
    track("story_prev", "media_interaction", { story_id: feeds[state.reel].id, segment: state.seg });
    if (state.seg > 0) { state.seg--; renderSegment(); return; }
    if (state.reel > 0) { state.reel--; state.seg = Math.max(0, feeds[state.reel].segments.length - 1); renderReel(); }
    else renderSegment();
  }
  function nextReel() { if (state.reel + 1 < feeds.length) { state.reel++; state.seg = 0; renderReel(); } else closeViewer("end"); }
  function togglePlay() {
    var v = state.video; if (!v) return;
    if (state.playing) { v.pause(); state.playing = false; V.toggle.textContent = "▶"; V.toggle.setAttribute("aria-label", "Lecture"); clearTimeout(state.watchdog); track("story_pause", "media_interaction", { story_id: feeds[state.reel].id }); }
    else { v.play().catch(function () {}); state.playing = true; V.toggle.textContent = "❚❚"; V.toggle.setAttribute("aria-label", "Pause"); armWatchdog(); }
  }
  function setMuted(m) {
    state.muted = m; if (state.video) state.video.muted = m;
    V.mute.textContent = m ? "🔇" : "🔊"; V.mute.setAttribute("aria-label", m ? "Activer le son" : "Couper le son");
    try { localStorage.setItem("ecrilo:stories:muted", m ? "1" : "0"); } catch (e) {}
  }

  /* ── Clavier + focus-trap ─────────────────────────────────────── */
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); closeViewer("escape"); return; }
    if (e.key === "ArrowRight") { e.preventDefault(); next(); return; }
    if (e.key === "ArrowLeft") { e.preventDefault(); prev(); return; }
    if (e.key === " ") { e.preventDefault(); togglePlay(); return; }
    if (e.key === "Tab") {
      var f = viewer.querySelectorAll("button, a[href]"); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ── Gestes : tap-zones, maintien = pause, swipe latéral, swipe bas = fermer ── */
  function bindGestures(stage) {
    var sx = 0, sy = 0, t0 = 0, moved = false, held = false, holdTimer = 0, pausedByHold = false;
    stage.addEventListener("pointerdown", function (e) {
      if (e.target.closest("button, a")) return;
      sx = e.clientX; sy = e.clientY; t0 = Date.now(); moved = false; held = false;
      holdTimer = setTimeout(function () { held = true; if (state.playing) { pausedByHold = true; togglePlay(); } }, 260);
    });
    stage.addEventListener("pointermove", function (e) { if (Math.abs(e.clientX - sx) > 12 || Math.abs(e.clientY - sy) > 12) { moved = true; clearTimeout(holdTimer); } });
    stage.addEventListener("pointerup", function (e) {
      clearTimeout(holdTimer);
      if (e.target.closest("button, a")) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (held) { if (pausedByHold) { pausedByHold = false; togglePlay(); } return; }
      if (moved) {
        if (dy > 80 && Math.abs(dx) < 60) { closeViewer("swipe"); return; }
        if (Math.abs(dx) > 60) { if (dx < 0) nextReelFromSwipe(); else prevReelFromSwipe(); return; }
        return;
      }
      if (Date.now() - t0 > 400) return;
      var rect = stage.getBoundingClientRect();
      if ((e.clientX - rect.left) / rect.width < 0.3) prev(); else next();
    });
    stage.addEventListener("pointercancel", function () { clearTimeout(holdTimer); });
  }
  function nextReelFromSwipe() { if (state.reel + 1 < feeds.length) { state.reel++; state.seg = 0; renderReel(); } }
  function prevReelFromSwipe() { if (state.reel > 0) { state.reel--; state.seg = 0; renderReel(); } }

  doc.addEventListener("visibilitychange", function () { if (doc.hidden && state.playing) togglePlay(); });

  // WCAG 2.2.2 : un mécanisme visible pour arrêter les aperçus en boucle.
  var pauseBtn = doc.querySelector("[data-ec-stories-pause]");
  if (pauseBtn && !canPreview) {
    // Mouvement réduit, économiseur de données, ou pas d'IntersectionObserver :
    // aucun aperçu ne jouera jamais. Une commande de pause n'aurait rien à
    // mettre en pause, et « Relancer » ne relancerait rien — soit exactement le
    // défaut qu'on corrige ici. On retire le bouton plutôt que de l'offrir inerte.
    pauseBtn.hidden = true;
  }
  function applyPreviews() {
    if (pauseBtn) {
      pauseBtn.setAttribute("aria-pressed", previewsOff ? "true" : "false");
      pauseBtn.textContent = previewsOff ? "Relancer les aperçus" : "Mettre en pause les aperçus";
    }
    if (previewsOff) {
      doc.querySelectorAll(".ec-story__preview").forEach(function (v) {
        try { v.pause(); } catch (e) {}
        var st = v.closest(".ec-story");
        if (st) st.classList.remove("is-previewing");
      });
      return;
    }
    // Relance. Cette branche manquait : la fonction changeait le libellé du
    // bouton et s'arrêtait là. Les vidéos restaient en pause, et l'observateur
    // ne les relançait pas non plus puisque leur visibilité n'avait pas changé.
    visibles.forEach(jouerApercu);
  }
  if (pauseBtn) {
    pauseBtn.addEventListener("click", function () {
      previewsOff = !previewsOff;
      try { localStorage.setItem("ecrilo:stories:previews", previewsOff ? "off" : "on"); } catch (e) {}
      applyPreviews();
      track("story_previews_" + (previewsOff ? "off" : "on"), "media_interaction", {});
    });
    applyPreviews();
  }
})();
